import "./Assets/scss/index.scss";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOMClient from "react-dom/client";
import * as _ from "lodash";
import { initMsal, msalInstance } from "./Api";
import App from "./Components/Layout";
import IconLibrary from "./Helpers/iconLibrary";
import { MsalProvider } from "@azure/msal-react";
import SignalrHelper from "./Helpers/signalr";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const signalr = new SignalrHelper();
signalr.listenForFileExportEvents();
signalr.listenForChangeRequestUpdates((id) => {
    console.log("Update received for:", id);
});
const queryClient = new QueryClient();
declare var require: any;
declare var module: any;
declare var window: any;
declare var process: any;

IconLibrary.init();

const inIframe: Function = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

// const ENVIRONMENT: string = process.env.NODE_ENV.toLowerCase();
// const DEVELOPMENT_ENVIRONMENTS: string[] = ["emulator", "local", "development"];
// const PRODUCTION_ENVIRONMENTS: string[] = ["test", "production"];

const history: any = createBrowserHistory();

// const debounceNotify: any = _.debounce((notify) => {
//     return notify();
// }, 125);

// let middleWares: any = compose(
//     applyMiddleware(thunk),
//     batchedSubscribe((notify) => {
//         debounceNotify(notify);
//     })
// );

// if (DEVELOPMENT_ENVIRONMENTS.indexOf(ENVIRONMENT) > -1) {
//     middleWares = composeWithDevTools(
//         applyMiddleware(thunk),
//         batchedSubscribe((notify) => {
//             debounceNotify(notify);
//         })
//     );
// }

// const store: Store<any> = createStore(
//     createRootReducer(),
//     compose(applyMiddleware(thunk))
// );

const root = ReactDOMClient.createRoot(document.getElementById("root")!);

const run: Function = async () => {
    initMsal();

    if (!inIframe()) {
        root.render(
            <MsalProvider instance={msalInstance}>
                <QueryClientProvider client={queryClient}>
                    <App />
                </QueryClientProvider>
            </MsalProvider>
        );

        // if (module && module.hot) {
        //     module.hot.accept("./Components/Layout/", () => {
        //         const Root: any = require("./Components/Layout/").default;
        //         root.render(
        //             <MsalProvider instance={msalInstance}>
        //                 <Provider store={store}>
        //                     <Root />
        //                 </Provider>
        //             </MsalProvider>
        //         );
        //     });
        // }
    }
};

// run app after DOM has been loaded
Promise.all([
    new Promise((resolve) => {
        window.addEventListener("DOMContentLoaded", resolve);
    }),
]).then(run());

export { history };
// export default store;
